<template>
	<div class="d-inline-block">
		<span @click.prevent="onClick">
			<slot></slot>
		</span>
		<lifeline-donation-modal
			v-if="showModal"
			@close="onClose"
			:showModal="showModal"
			:id="props.id"
			:dstyle="props.dstyle"
		></lifeline-donation-modal>
	</div>
</template>

<script setup lang="ts">
import { ref, watch, onBeforeUnmount } from 'vue';
import { ElLoading } from 'element-plus';
import { useDonationFormsStore } from '../store';

const props = defineProps(['id', 'dstyle']);
const showModal = ref(false);
const store = useDonationFormsStore();

let loadingInstance: ReturnType<typeof ElLoading.service> | null = null;
let safetyTimeout: any = null;

const closeLoader = () => {
	if (loadingInstance) {
		loadingInstance.close();
		loadingInstance = null;
	}
	if (safetyTimeout) {
		clearTimeout(safetyTimeout);
		safetyTimeout = null;
	}
};

const onClick = () => {
	if (showModal.value) return;
	showModal.value = true;

	// Fullscreen ElLoading until the dialog actually opens.
	loadingInstance = ElLoading.service({
		fullscreen: true,
		lock: true,
		background: 'rgba(255, 255, 255, 0.85)',
	});

	// Safety net: if getData() fails or never resolves, drop the loader and
	// unmount the modal so the user isn't stuck.
	safetyTimeout = setTimeout(() => {
		if (!store.showModal) {
			showModal.value = false;
			closeLoader();
		}
	}, 15000);
};

const onClose = () => {
	showModal.value = false;
	closeLoader();
	if (typeof jQuery !== 'undefined') {
		jQuery('html').removeClass('modalOpen');
	}
};

// As soon as the dialog actually opens, close the loader.
watch(
	() => store.showModal,
	(val) => {
		if (val) closeLoader();
	}
);

onBeforeUnmount(closeLoader);
</script>
